import { CertificateDetailsModel } from 'models/certificate.model';

export type GeneralConfigModel = {
  id: keyof CertificateDetailsModel;
};

const generalConfig: GeneralConfigModel[] = [
  {
    id: 'productName',
  },
  {
    id: 'productId',
  },
  {
    id: 'countryOfOrigin',
  },
  {
    id: 'batchNumber',
  },
  {
    id: 'factory',
  },
];

export { generalConfig };
